{
  "REPORT": {
    "HEADER": "Sarunas",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_AGENT_REPORTS": "Lejupielādēt aģentu pārskatus",
    "DATA_FETCHING_FAILED": "Neizdevās izgūt datus. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "SUMMARY_FETCHING_FAILED": "Neizdevās izgūt kopsavilkumu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Saņemtās ziņas",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Nosūtītās ziņas",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Nodošanas Skaits",
        "DESC": "( Kopā )"
      },
      "REPLY_TIME": {
        "NAME": "Klienta gaidīšanas laiks",
        "TOOLTIP_TEXT": "Gaidīšanas laiks ir {metricValue} (pamatojoties uz {conversationCount} atbildēm)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Šodien",
      "YESTERDAY": "Vakar",
      "LAST_7_DAYS": "Pēdējās 7 dienas",
      "LAST_30_DAYS": "Pēdējās 30 dienas",
      "THIS_MONTH": "Šis mēnesis",
      "LAST_MONTH": "Pagājušais mēnesis",
      "LAST_3_MONTHS": "Pēdējie 3 mēneši",
      "LAST_6_MONTHS": "Pēdējie 6 mēneši",
      "LAST_YEAR": "Pagājušais gads",
      "CUSTOM_DATE_RANGE": "Pielāgots datumu diapazons"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Grupēt Pēc",
    "DURATION_FILTER_LABEL": "Ilgums",
    "GROUPING_OPTIONS": {
      "DAY": "Diena",
      "WEEK": "Nedēļa",
      "MONTH": "Mēnesis",
      "YEAR": "Gads"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Nedēļa"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Nedēļa"
      },
      {
        "id": 3,
        "groupBy": "Mēnesis"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Nedēļa"
      },
      {
        "id": 3,
        "groupBy": "Mēnesis"
      },
      {
        "id": 4,
        "groupBy": "Mēnesis"
      }
    ],
    "BUSINESS_HOURS": "Darba Laiks",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Notīrīt filtru",
      "EMPTY_LIST": "Nav atrasts"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Sarunas: {count}",
      "RESULT_COUNT_MESSAGE": "Ziņas: {count}",
      "EMPTY": "Šim stabiņam ieraksti netika atrasti.",
      "ERROR": "Ierakstus neizdevās ielādēt. Lūdzu, mēģiniet vēlreiz.",
      "LOAD_MORE": "Ielādēt vairāk",
      "PREVIOUS_BUCKET": "Iepriekšējais stabiņš",
      "NEXT_BUCKET": "Nākamais stabiņš",
      "UNKNOWN_CONTACT": "Nezināms kontakts",
      "UNKNOWN_INBOX": "Nezināma iesūtne",
      "UNASSIGNED_AGENT": "Nav piešķirts",
      "NO_MESSAGE_CONTENT": "Ziņai nav satura",
      "MESSAGE_CREATED_AT": "Ziņa izveidota {time}",
      "EVENT_OCCURRED_AT": "Notikums notika {time}",
      "INCOMING_MESSAGE": "Saņemtā ziņa",
      "OUTGOING_MESSAGE": "Nosūtītā ziņa",
      "VIEW_ALL": "Skatīt sarunās",
      "VIEW_ALL_LIMIT": "Sarunu sarakstā var atvērt tikai stabiņus ar ne vairāk kā {limit} sarunām.",
      "HIDDEN_COUNT": "Netiek rādīts, jo neesat to iesūtnes dalībnieks: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Rāda {start} līdz {end} no {total} rezultātiem",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Aģentu Pārskats",
    "DESCRIPTION": "Ērti izsekojiet aģenta darbībai, izmantojot galvenos rādītājus, piemēram, sarunas, atbildes laikus, atrisināšanas laikus un atrisinātos gadījumus. Noklikšķiniet uz aģenta vārda, lai uzzinātu vairāk.",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_AGENT_REPORTS": "Lejupielādēt aģentu pārskatus",
    "FILTER_DROPDOWN_LABEL": "Izvēlieties Aģentu",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Ienākošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Izejošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Pēdējās 7 dienas"
      },
      {
        "id": 1,
        "name": "Pēdējās 30 dienas"
      },
      {
        "id": 2,
        "name": "Pēdējie 3 mēneši"
      },
      {
        "id": 3,
        "name": "Pēdējie 6 mēneši"
      },
      {
        "id": 4,
        "name": "Pagājušais gads"
      },
      {
        "id": 5,
        "name": "Pielāgots datumu diapazons"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Etiķešu Pārskats",
    "DESCRIPTION": "Sekojiet līdzi etiķešu veiktspējai ar galvenajiem rādītājiem, tostarp sarunām, atbildes laikiem, atrisināšanas laikiem un atrisinātajiem gadījumiem.",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_LABEL_REPORTS": "Lejupielādēt etiķešu pārskatus",
    "FILTER_DROPDOWN_LABEL": "Izvēlieties Etiķeti",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Ienākošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Izejošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Pēdējās 7 dienas"
      },
      {
        "id": 1,
        "name": "Pēdējās 30 dienas"
      },
      {
        "id": 2,
        "name": "Pēdējie 3 mēneši"
      },
      {
        "id": 3,
        "name": "Pēdējie 6 mēneši"
      },
      {
        "id": 4,
        "name": "Pagājušais gads"
      },
      {
        "id": 5,
        "name": "Pielāgots datumu diapazons"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Iesūtnes Pārskats",
    "DESCRIPTION": "Ātri apskatiet iesūtnes veiktspēju, izmantojot galvenos rādītājus, piemēram, sarunas, atbildes laikus, atrisināšanas laikus un atrisinātos gadījumus. Lai iegūtu plašāku informāciju, noklikšķiniet uz iesūtnes nosaukuma.",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_INBOX_REPORTS": "Lejupielādēt iesūtnes pārskatus",
    "FILTER_DROPDOWN_LABEL": "Izvēlieties Iesūtni",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Ienākošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Izejošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Pēdējās 7 dienas"
      },
      {
        "id": 1,
        "name": "Pēdējās 30 dienas"
      },
      {
        "id": 2,
        "name": "Pēdējie 3 mēneši"
      },
      {
        "id": 3,
        "name": "Pēdējie 6 mēneši"
      },
      {
        "id": 4,
        "name": "Pagājušais gads"
      },
      {
        "id": 5,
        "name": "Pielāgots datumu diapazons"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Komandas Pārskats",
    "DESCRIPTION": "Iegūstiet pārskatu par savas komandas veiktspēju, izmantojot būtiskus rādītājus, tostarp sarunas, atbildes laikus, atrisināšanas laikus un atrisinātos gadījumus. Lai iegūtu sīkāku informāciju, noklikšķiniet uz komandas nosaukuma.",
    "LOADING_CHART": "Notiek diagrammas datu ielāde...",
    "NO_ENOUGH_DATA": "Mēs neesam saņēmuši pietiekami daudz datu punktu, lai izveidotu pārskatu. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "DOWNLOAD_TEAM_REPORTS": "Lejupielādēt komandas pārskatus",
    "FILTER_DROPDOWN_LABEL": "Izvēlieties Komandu",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Sarunas",
        "DESC": "( Kopā )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Ienākošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Izejošie ziņojumi",
        "DESC": "( Kopā )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmās Atbildes Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Pirmās Atbildes Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Atrisināšanas Laiks",
        "DESC": "( Vidēji )",
        "INFO_TEXT": "Kopējais aprēķiniem izmantoto sarunu skaits:",
        "TOOLTIP_TEXT": "Atrisināšanas Laiks ir {metricValue} (pamatojoties uz {conversationCount} sarunām)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Atrisināšanas Skaits",
        "DESC": "( Kopā )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Pēdējās 7 dienas"
      },
      {
        "id": 1,
        "name": "Pēdējās 30 dienas"
      },
      {
        "id": 2,
        "name": "Pēdējie 3 mēneši"
      },
      {
        "id": 3,
        "name": "Pēdējie 6 mēneši"
      },
      {
        "id": 4,
        "name": "Pagājušais gads"
      },
      {
        "id": 5,
        "name": "Pielāgots datumu diapazons"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Pielietot",
      "PLACEHOLDER": "Izvēlieties datumu diapazonu"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Pārskati",
    "NO_RECORDS": "CSAT aptaujas atbildes nav pieejamas.",
    "DOWNLOAD": "Lejupielādēt CSAT Pārskatus",
    "DOWNLOAD_FAILED": "Neizdevās lejupielādēt CSAT Pārskatus",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Izvēlieties Aģentus"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontaktpersona",
        "AGENT_NAME": "Piešķirtais aģents",
        "RATING": "Vērtējums",
        "FEEDBACK_TEXT": "Atsauksmes komentārs"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Kopējais atbilžu skaits",
        "TOOLTIP": "Kopējais apkopoto atbilžu skaits"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Apmierinātības rādītājs",
        "TOOLTIP": "Kopējais pozitīvo atbilžu skaits / Kopējais atbilžu skaits * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Atbildes ātrums",
        "TOOLTIP": "Kopējais atbilžu skaits / Kopējais nosūtīto CSAT aptaujas ziņojumu skaits * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Robotu Atskaites",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Sarunu Skaits",
        "TOOLTIP": "Kopējais sarunu skaits ar robota ziņojumiem"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Atbilžu Skaits",
        "TOOLTIP": "Kopējais izejošo ziņojumu skaits"
      },
      "MESSAGE_COUNT": {
        "LABEL": "AI Atbilžu Skaits",
        "TOOLTIP": "Kopējais robota nosūtīto atbilžu ziņojumu skaits"
      },
      "COPILOT_COUNT": {
        "LABEL": "Sagatavoto Atbilžu Skaits",
        "TOOLTIP": "Kopējais robota aģentiem sagatavoto copilot ieteikumu skaits"
      },
      "SUCCESS_RATE": {
        "LABEL": "AI Atrisinātas",
        "TOOLTIP": "To sarunu procentuālā daļa, kuras AI atrisinājis bez nodošanas aģentam"
      },
      "RESOLVE_TIME": {
        "LABEL": "Atrisināšanas Laiks",
        "TOOLTIP": "Mediānais laiks no pirmā klienta ziņojuma līdz pēdējam robota/aģenta ziņojumam"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Sarunu Skaits",
        "TOOLTIP": "Kopējais robota apstrādāto sarunu skaits"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Kopējais atbilžu skaits",
        "TOOLTIP": "Kopējais robota nosūtīto atbilžu skaits"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Atrisināšanas Apjoms",
        "TOOLTIP": "Kopējais robota atrisināto sarunu skaits / kopējais robota apstrādāto sarunu skaits * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Nodošanas Apjoms",
        "TOOLTIP": "Kopējais aģentiem nodoto sarunu skaits / kopējais robota apstrādāto sarunu skaits * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Negrupēt",
      "INBOXES": "Iesūtnes",
      "LABELS": "Etiķetes"
    },
    "GROUPED": {
      "CHART_TITLE": "Sadalījums pa grupām",
      "BACK_TO_ALL": "Rādīt visu",
      "TABLE": {
        "INBOX": "Iesūtne",
        "LABEL": "Etiķete",
        "CONVERSATIONS": "Sarunas",
        "MESSAGES": "Ziņojumi",
        "MESSAGES_TOOLTIP": "Kopējais izejošo ziņojumu skaits",
        "AI_MESSAGES": "AI Atbildes",
        "AI_MESSAGES_TOOLTIP": "Kopējais AI atbilžu skaits, aiz kura seko klientu pozitīvo un negatīvo vērtējumu skaits",
        "THUMBS_UP_TOOLTIP": "AI atbilžu skaits, kuras klienti novērtējuši pozitīvi (īkšķis augšup)",
        "THUMBS_DOWN_TOOLTIP": "AI atbilžu skaits, kuras klienti novērtējuši negatīvi (īkšķis lejup)",
        "PREPARED": "Sagatavotās Atbildes",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Šīs grupas ziņojumu procentuālā daļa no visiem ziņojumiem",
        "BOT_RESPONSES": "AI Atbildes %",
        "SUGGESTION_USED": "Izmantotās Atbildes",
        "SUGGESTION_USED_TOOLTIP": "To šīs grupas sagatavoto atbilžu procentuālā daļa, kuras izmantojuši aģenti",
        "SUGGESTION_NOT_USED": "Neizmantotās Atbildes",
        "SUGGESTION_NOT_USED_TOOLTIP": "To šīs grupas ziņojumu procentuālā daļa, kuriem bija sagatavota atbilde, taču tā netika izmantota"
      },
      "NOTES": {
        "TITLE": "Kā tiek aprēķināti rādītāji",
        "CONVERSATIONS": "To sarunu skaits, kurām izvēlētajā periodā ir vismaz viens izejošs ziņojums.",
        "MESSAGES": "Kopējais izvēlētajā periodā nosūtīto izejošo (nav privātu) ziņojumu skaits. Tas ietver gan AI ģenerētus, gan cilvēka rakstītus ziņojumus.",
        "PERCENTAGE": "Šīs grupas ziņojumu daļa no visiem izejošajiem ziņojumiem visās grupās.",
        "AI_MESSAGES": "To izejošo ziņojumu skaits, kurus automātiski nosūtījis AI robots (neskaitot aģentiem sagatavotās atbildes). Skaitļi iekavās rāda, cik no šīm atbildēm klienti novērtējuši pozitīvi (īkšķis augšup) un negatīvi (īkšķis lejup).",
        "PREPARED": "To copilot ieteikumu (sagatavoto atbilžu) skaits, kurus AI robots izvēlētajā periodā ģenerējis aģentiem. Tie ir privāti ziņojumi, redzami tikai aģentiem, un netiek skaitīti kā izejoši ziņojumi, tāpēc šis skaitlis var nesakrist ar kolonnu Ziņojumi.",
        "SUGGESTION_USED": "To šīs grupas sagatavoto atbilžu procentuālā daļa, kuras izmantojuši aģenti. Tas var nesakrist ar kolonnu Sagatavotās Atbildes, jo var iekļaut arī iepriekšējos periodos ģenerētos ieteikumus.",
        "SUGGESTION_NOT_USED": "To šīs grupas izejošo ziņojumu procentuālā daļa, kuriem bija pieejams copilot ieteikums, taču aģents atbildēja, to neizmantojot. Skaitīts tikai tad, ja aģents faktiski nosūtīja atbildi. Tas var nesakrist ar kolonnu Sagatavotās Atbildes, jo var iekļaut arī iepriekšējos periodos ģenerētos ieteikumus."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Pārskats",
    "LIVE": "Tiešraide",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Atvērt Sarunas",
      "LOADING_MESSAGE": "Notiek sarunu metrikas ielāde...",
      "OPEN": "Atvērt",
      "UNATTENDED": "Bez uzraudzības",
      "UNASSIGNED": "Nav piešķirtas",
      "PENDING": "Gaida"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Sarunu Satiksme",
      "NO_CONVERSATIONS": "Nav sarunu",
      "CONVERSATION": "{count} saruna",
      "CONVERSATIONS": "{count} sarunas",
      "DOWNLOAD_REPORT": "Lejupielādēt atskaiti"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Aģentu sarunas",
      "LOADING_MESSAGE": "Notiek aģentu metrikas ielāde...",
      "NO_AGENTS": "Aģentu sarunas nenotiek",
      "TABLE_HEADER": {
        "AGENT": "Aģents",
        "OPEN": "Atvērt",
        "UNATTENDED": "Bez uzraudzības",
        "STATUS": "Statuss"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "Visas Komandas",
      "HEADER": "Komandu sarunas",
      "LOADING_MESSAGE": "Notiek komandu metrikas ielāde...",
      "NO_TEAMS": "Dati nav pieejami",
      "TABLE_HEADER": {
        "TEAM": "Komanda",
        "OPEN": "Atvērt",
        "UNATTENDED": "Bez uzraudzības",
        "STATUS": "Statuss"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Aģenta statuss",
      "ONLINE": "Tiešsaistē",
      "BUSY": "Aizņemts",
      "OFFLINE": "Bezsaistē"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Svētdiena",
    "MONDAY": "Pirmdiena",
    "TUESDAY": "Otrdiena",
    "WEDNESDAY": "Trešdiena",
    "THURSDAY": "Ceturtdiena",
    "FRIDAY": "Piektdiena",
    "SATURDAY": "Sestdiena"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Atskaites",
    "NO_RECORDS": "SLA sarunas nav pieejamas.",
    "LOADING": "Notiek SLA datu ielāde...",
    "DOWNLOAD_SLA_REPORTS": "Lejupielādēt SLA atskaites",
    "DOWNLOAD_FAILED": "Neizdevās lejupielādēt SLA atskaites",
    "DROPDOWN": {
      "ADD_FIlTER": "Pievienot filtru",
      "CLEAR_ALL": "Notīrīt visu",
      "CLEAR_FILTER": "Notīrīt filtru",
      "EMPTY_LIST": "Nav atrasts",
      "NO_FILTER": "Nav pieejami filtri",
      "SEARCH": "Meklēšanas filtrs",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA nosaukums",
        "AGENTS": "Aģenta vārds",
        "INBOXES": "Iesūtnes nosaukums",
        "LABELS": "Etiķetes nosaukums",
        "TEAMS": "Komandas nosaukums"
      },
      "SLA": "SLA politika",
      "INBOXES": "Iesūtne",
      "AGENTS": "Aģents",
      "LABELS": "Etiķete",
      "TEAMS": "Komanda"
    },
    "WITH": "ar",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Rezultātu Līmenis",
        "TOOLTIP": "Izveidoto SLA procentuālā daļa tika veiksmīgi pabeigta"
      },
      "NO_OF_MISSES": {
        "LABEL": "Nokavēto Skaits",
        "TOOLTIP": "Kopējais nokavēto SLA skaits noteiktā periodā"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Sarunu Skaits",
        "TOOLTIP": "Kopējais sarunu skaits ar SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Politika",
        "CONVERSATION": "Saruna",
        "AGENT": "Aģents"
      },
      "VIEW_DETAILS": "Skatīt Detaļas"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Starpsumma",
    "NO_TEAM": "Nav komandas",
    "GROUP_BY_TEAMS": "Grupēt pēc komandām",
    "INBOX": "Iesūtne",
    "AGENT": "Aģents",
    "TEAM": "Komanda",
    "LABEL": "Etiķete",
    "TOTAL": "Kopā",
    "AVG_RESOLUTION_TIME": "Vid. Atrisināšanas Laiks",
    "AVG_FIRST_RESPONSE_TIME": "Vid. Pirmās Atbildes Laiks",
    "AVG_REPLY_TIME": "Vid. Klientu Gaidīšanas Laiks",
    "RESOLUTION_COUNT": "Atrisināšanas Skaits",
    "CONVERSATIONS": "Sarunu skaits",
    "OUTGOING_CHATS": "Izejošās tērzēšanas",
    "OUTGOING_EMAILS": "Izejošie e-pasti",
    "PHONE_CALLS": "Tālruņa zvani",
    "INBOUND_CALLS": "Ienākošie zvani",
    "OUTBOUND_CALLS": "Izejošie zvani",
    "TOTAL_ACTIVITIES": "Kopējās aktivitātes",
    "ONLINE_TIME": "Tiešsaistes laiks",
    "QUEUE_AVAILABLE_TIME": "Pieejamības laiks rindā",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Šī aģenta nosūtīto izejošo ziņojumu skaits",
      "OUTGOING_EMAILS": "Šī aģenta nosūtīto izejošo e-pastu skaits",
      "PHONE_CALLS": "Kopējais šim aģentam piešķirto tālruņa zvanu skaits (ienākošo un izejošo zvanu summa)",
      "TOTAL_ACTIVITIES": "Kopējais aktivitāšu skaits: ienākošie zvani + izejošie zvani + izejošās tērzēšanas + izejošie e-pasti",
      "INBOUND_CALLS": "Šim aģentam piešķirto ienākošo tālruņa zvanu skaits",
      "OUTBOUND_CALLS": "Šim aģentam piešķirto izejošo tālruņa zvanu skaits",
      "AVG_FIRST_RESPONSE_TIME": "Vidējais laiks no sarunas izveides līdz pirmajai aģenta atbildei šim aģentam piešķirtajās sarunās",
      "AVG_RESOLUTION_TIME": "Vidējais laiks no sarunas izveides līdz atrisināšanai šim aģentam piešķirtajās sarunās",
      "AVG_REPLY_TIME": "Vidējais laiks, ko klienti gaida no sava ziņojuma līdz aģenta atbildei šim aģentam piešķirtajās sarunās",
      "ONLINE_TIME": "Kopējais laiks, ko aģents izvēlētajā periodā bija tiešsaistē vai aizņemts",
      "QUEUE_AVAILABLE_TIME": "Kopējais laiks, ko aģents izvēlētajā periodā bija pieejams tālruņa rindās"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Tālruņa Pārskati",
    "DESCRIPTION": "Sekojiet līdzi tālruņa zvanu rādītājiem ar detalizētu ieskatu ienākošajos un izejošajos zvanos, grupētiem pēc aģenta vai iesūtnes visaptverošai analīzei.",
    "DOWNLOAD_PHONE_REPORTS": "Lejupielādēt Tālruņa Pārskatus",
    "GROUP_BY": {
      "LABEL": "Grupēt Pēc",
      "AGENT": "Aģents",
      "INBOX": "Iesūtne"
    },
    "TABLE": {
      "TOTAL_CALLS": "Kopā",
      "INBOUND_CALLS": "Ienākošie",
      "OUTBOUND_CALLS": "Izejošie",
      "FAILED_OUTBOUND_CALLS": "Neizdevušies izejošie",
      "AVG_AGENT_HANDLED_DURATION": "Vid. Ilgums",
      "TOTAL_AGENT_HANDLED_DURATION": "Kopējais Ilgums",
      "AVG_RINGING_TIME": "Vid. Zvanīšanas Laiks",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Veiksmes %",
      "UNIQUE_CALLERS": "Unikālie Zvanītāji",
      "UNIQUE_CALLED_CONTACTS": "Unikāli Izsauktie",
      "UNANSWERED_MISSED_CALLS": "Neatbildēti bez atzvana",
      "UNANSWERED_MISSED_PERCENTAGE": "Neatbildētie %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Neatbildēti bez atzvana, nepietiekami pārzvanīti",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Neatbildēti bez atzvana, nepietiekami pārzvanīti %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Kopējais visu zvanu skaits (ieskaitot nesavienotos)",
      "INBOUND_CALLS": "Savienoto zvanu skaits",
      "OUTBOUND_CALLS": "Visu izejošo zvanu skaits (ieskaitot nesavienotos)",
      "FAILED_OUTBOUND_CALLS": "Izejošo zvanu skaits, kuriem neizdevās izveidot savienojumu",
      "AVG_AGENT_HANDLED_DURATION": "Vidējais aģentu apstrādāto zvanu ilgums",
      "TOTAL_AGENT_HANDLED_DURATION": "Kopējais visu aģentu apstrādāto zvanu ilgums",
      "AVG_RINGING_TIME": "Vidējais laiks, cik ilgi zvani zvanījuši pirms atbildēšanas",
      "CONNECTED_OUTBOUND_PERCENTAGE": "To izejošo zvanu procentuālā daļa, kas veiksmīgi savienoti",
      "UNIQUE_CALLERS": "Unikālo kontaktpersonu skaits, kas veikušas ienākošos zvanus",
      "UNIQUE_CALLED_CONTACTS": "Unikālo kontaktpersonu skaits, kurām veikti izejošie zvani",
      "UNANSWERED_MISSED_CALLS": "To neatbildēto zvanu skaits, kuriem nav veikts veiksmīgs atzvans (zvans savienots). Var iekļaut zvanus, kurus vēl var apstrādāt darba dienas ietvaros",
      "UNANSWERED_MISSED_PERCENTAGE": "To unikālo zvanītāju procentuālā daļa, kuru zvani palikuši neatbildēti bez atzvana (neatbildētie zvani bez atzvana / unikālie zvanītāji)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "To neatbildēto zvanu skaits, kuriem veikti mazāk nekā 2 atzvanīšanas mēģinājumi. Var iekļaut zvanus, kurus vēl var apstrādāt darba dienas ietvaros",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "To unikālo zvanītāju procentuālā daļa, kuriem veikti mazāk nekā 2 atzvanīšanas mēģinājumi ((neatbildēti bez atzvana - pietiekami apstrādāti) / unikālie zvanītāji)"
    }
  }
}
